import { MapContainer, TileLayer, Marker, Popup, useMap } from "react-leaflet";
import { useTranslation } from "react-i18next";
import GroupsIcon from '@mui/icons-material/Groups';
import { Box } from "@mui/material";
import ListOfClubs from "./ListOfClubs";
import { club } from 'apis';
import { useQuery } from "react-query";
import { useEffect, useRef, useState } from "react";
import L from "leaflet";
import "leaflet/dist/leaflet.css";


const defaultIcon = L.icon({
    iconUrl: "https://cdnjs.cloudflare.com/ajax/libs/leaflet/1.7.1/images/marker-icon.png",
    iconRetinaUrl: "https://cdnjs.cloudflare.com/ajax/libs/leaflet/1.7.1/images/marker-icon-2x.png",
    shadowUrl: "https://cdnjs.cloudflare.com/ajax/libs/leaflet/1.7.1/images/marker-shadow.png",
    iconSize: [25, 41],
    iconAnchor: [12, 41],
    popupAnchor: [1, -34],
  });

const LeafletMap = () => {
  const { t } = useTranslation();


  const [positions, setPositions] = useState<any[]>([]);
  const [selectedPosition, setSelectedPosition] = useState<[number, number] | null>(null);
  const mapRef = useRef<L.Map | null>(null);


  const { data: clubsData } = useQuery(
    "geolocation",
    async () => {
      const res = await club.getClubsPublic();
      return res;
    },
    { suspense: false }
  );

  useEffect(() => {
    if (clubsData) {

      const mappedPositions: any[] = clubsData
        .filter((club: any) => club.latitude !== null && club.longitude !== null)
        .map((club: any) => ({
          id: club.id,
          lat: club.latitude!,
          lng: club.longitude!,
          popupText: club.title,
          address1: club.address1!
        }));

      setPositions(mappedPositions);
    }
  }, [clubsData]);


  useEffect(() => {
    if (selectedPosition && mapRef.current) {
      mapRef.current.setView(selectedPosition, 12);
    }
  }, [selectedPosition]);

  const clubs = (clubsData || []).map((club: any) => ({
    icon: <GroupsIcon fontSize="small" />,
    title: club.title,
    address1: club.address1,
    description: `Club ID: ${club.id}`,
    lat: club.latitude!,
    lng: club.longitude!
  }));

  const handleClick = (title: string, lat: number | null, lng: number | null) => {
    if (lat !== null && lng !== null) {
      setSelectedPosition([lat, lng]);
    }
  };

  const FixMap = () => {
    const map = useMap();
    useEffect(() => {
      setTimeout(() => {
        map.invalidateSize();
      }, 50);
    }, [map]);
    return null;
  };

  return (
    <Box sx={{ display: "flex", height: "100%", width: "100%" }}>

      <ListOfClubs clubs={clubs} handleClick={(title, lat, lng) => handleClick(title, lat, lng)} t={t}></ListOfClubs>

      <Box sx={{ flex: 1, height: "100%" }}>
        <MapContainer center={selectedPosition || [37.983, 23.727]} zoom={7} style={{ height: "100%", maxHeight: 630, width: "100%" }} whenReady={() => {}}
          ref={mapRef}>
          <TileLayer url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png" />
          {positions?.map((position) => (
            <Marker key={position.id} position={[position.lat, position.lng]} icon={defaultIcon}>
              <Popup>{position.popupText}</Popup>
            </Marker>
          ))}
          <FixMap/>
        </MapContainer>
      </Box>
    </Box>
  );
};

export default LeafletMap;
